import { httpApi } from '@api/http.api.ts';
import type { VesselStatistic as VesselResponse } from '@routes/sidebar/admin-center/___shared___/dashboards/types.ts';
import type { CommonTableRequest } from '@routes/sidebar/admin-center/___shared___/types.ts';

export type VesselRequest = CommonTableRequest;

export interface GetVesselParams {
    tenantAlias: string;
    vesselId: number;
    payload: VesselRequest;
}

const getVesselBaseUrl = (tenantAlias: string, vesselId: number) =>
    `admin-center/tenants/${tenantAlias}/statistics/vessel/${vesselId}`;

export const getApiVessel = ({ tenantAlias, vesselId, payload }: GetVesselParams): Promise<VesselResponse> =>
    httpApi.post<VesselResponse>(`${getVesselBaseUrl(tenantAlias, vesselId)}/search`, payload).then(({ data }) => data);
